import AlertDialogOnClose from "../../../../components/admin/AlertDiologOnClose";
import ListaProdutos from "./ListaProdutos";

export default function ProdutoForm() {
    return (
        <AlertDialogOnClose nome={"Produto"} placeholder={"Pesquisar por nome"}>
            <ListaProdutos />
        </AlertDialogOnClose>
    )
} 